import React from 'react';

import { CurrencyIcon, Thumbnail } from '@pkg/components';

import { tokens } from '../../DataTable.tokens';

import {
    CurrencyIconWrapper,
    Details,
    SkeletonSubtitle,
    SkeletonThumbnail,
    SkeletonTitle,
    StyledCollection,
    SubtitleContent,
    SubtitleLink,
    SubtitleValue,
    ThumbnailWrapper,
    TitleValue,
} from './Collection.style';

export interface DataTableCollectionProps {
    title: string;
    subtitle?: string;
    subtitleChain?: 'apt' | 'eth' | 'matic';
    subtitleUrl?: string;
    thumbnail?: string;
    thumbnailBorder?: boolean;
    thumbnailCircle?: boolean;
    truncate?: boolean;
}

export function Collection({
    title,
    subtitle,
    subtitleChain,
    subtitleUrl,
    thumbnail,
    thumbnailBorder = false,
    thumbnailCircle = false,
    truncate = false,
}: DataTableCollectionProps) {
    const subtitleChainMarkup = subtitleChain ? (
        <CurrencyIconWrapper>
            <CurrencyIcon currency={subtitleChain} />
        </CurrencyIconWrapper>
    ) : null;

    const subtitleChildren = subtitle?.length ? (
        <>
            <SubtitleValue $truncate={truncate}>{subtitle}</SubtitleValue>

            {subtitleChainMarkup}
        </>
    ) : null;

    // TODO: We either need to detect that the `url` is "external", or
    // we need to accept an explicit `external?: boolean;` prop.
    // If `external`, use: `target="_blank" rel="noopener noreferrer"`.
    const subtitleLinkMarkup =
        subtitleChildren && subtitleUrl?.length ? (
            <SubtitleLink to={subtitleUrl}>{subtitleChildren}</SubtitleLink>
        ) : null;

    const subtitleContentMarkup =
        subtitleChildren && !subtitleUrl ? <SubtitleContent>{subtitleChildren}</SubtitleContent> : null;

    return (
        <StyledCollection>
            <ThumbnailWrapper $border={thumbnailBorder} $circular={thumbnailCircle}>
                <Thumbnail imageUrl={thumbnail} mashWidth={tokens.collection.thumbnail.mashSize} />
            </ThumbnailWrapper>

            <Details>
                <TitleValue $truncate={truncate}>{title}</TitleValue>
                {subtitleLinkMarkup || subtitleContentMarkup}
            </Details>
        </StyledCollection>
    );
}

export function SkeletonCollection(_props: Partial<DataTableCollectionProps>) {
    return (
        <StyledCollection>
            <ThumbnailWrapper>
                <SkeletonThumbnail />
            </ThumbnailWrapper>

            <Details>
                <SkeletonTitle />
                <SkeletonSubtitle />
            </Details>
        </StyledCollection>
    );
}
